import React, { useContext, useState } from 'react';
import { DataContext } from '../../data/DataContext';
import { DropDown, Input, SwitchButton, DateInput, RadioButton } from "../controls";
import { tipoDocumentos, estadoCivil } from '../../data/MochaData';
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import Modal from "react-modal";
import { getAgeActuarial, getDateFronIdentity, getName } from '../../services/help';


const Step2 = () => {
    const { VivirSeguro, setVivirSeguro, changeHandler } = useContext(DataContext);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const changeTypeDoc = (event) => {
        setVivirSeguro({
            ...VivirSeguro, [event.target.name]: event.target.value, nombres: '', apellidos: '', edad: 0, numeroIdentificacion: ''
        });
    }

    const onChangeDoc = (event) => {
        if (event !== '' && event !== undefined) {
            const fechaNac = getDateFronIdentity(event.target.value);
            const edad = getAgeActuarial(fechaNac);
            setVivirSeguro({ ...VivirSeguro, [event.target.name]: event.target.value, edad: edad, fechaNacimiento: fechaNac });
        }
    }

    const onChangeDate = (event) => {
        const edad = getAgeActuarial(event);
        setVivirSeguro({ ...VivirSeguro, edad: edad, fechaNacimiento: event });

    }

    const onClickSearch = () => {
        clearData();
        setLoading(true);
        http(endPoints.ente(VivirSeguro.numeroIdentificacion, VivirSeguro.tipoIdentidad))
            .get()
            .then((res) => {
                let name = getName(res.nombre);
                let lastName = getName(res.apellido);

                console.log(name);

                setVivirSeguro({
                    ...VivirSeguro
                    , nombres: name.primero
                    , segundoNombre: name.segundo
                    , apellidos: lastName.primero
                    , segundoApellido: lastName.segundo
                    , telefonoCasa: res.telefonoCasa, telefonoPersonal: res.telefonoCelular
                    , correoElectronico: res.email, direccionDomicilio: res.direccion, departamento: res.departamento, cuidad: res.municipio
                    , cargando: false
                });

            })
            .catch((error) => {
                setVivirSeguro({ ...VivirSeguro, mensaje: 'No se encontro registro', cargando: false });
                handleShow();
            }).finally(() => { setLoading(false) });;

    };

    const clearData = () => (
        setVivirSeguro({
            ...VivirSeguro
            , nombres: '', apellidos: ''
            , telefonoCasa: '', telefonoPersonal: ''
            , correoElectronico: '', direccionDomicilio: '', mensaje: '', departamento: 0, cuidad: 0, edad: 0, fechaNacimiento: ''
        }));

    const changeChk = (question, value) => {
        setVivirSeguro({ ...VivirSeguro, [question]: value });
    }



    return (
        <div className="step">
            <div className="step-container-vivirseguro">
                <div>
                    <span className="title2-vsc">Detalles personales</span>
                </div>
                <div className="mt-10 mb-10">
                    <span className="lbl-paso-t2">(*) Espacios requeridos</span>
                </div>
                <div>
                    <span className="title3-vsc">¡Queremos conocerte! Ingres&aacute; los siguientes datos, seg&uacute;n tu documento de identidad</span>
                </div>
                <DropDown isrequired={true} label="Tipo de identificación*" dataProvider={tipoDocumentos} valueSelect={VivirSeguro.tipoIdentidad} fieldSelect="tipoIdentidad" field="tipoIdentidad" isRequired={true} onChangeSelect={changeTypeDoc} />
                {VivirSeguro.tipoIdentidad === "1" &&
                    <Input type="mask" label="Número de identificación*" value={VivirSeguro.numeroIdentificacion} field="numeroIdentificacion" onChange={onChangeDoc}
                        useiconSearch={true} onClickIconSearch={onClickSearch}
                        mask="999-999999-9999a"
                        pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                        title="Documento invalido" />
                }
                {VivirSeguro.tipoIdentidad !== "1" &&
                    <Input label="Número de identificación*" value={VivirSeguro.numeroIdentificacion} field="numeroIdentificacion" onChange={changeHandler}
                        useiconSearch={true} onClickIconSearch={onClickSearch} />
                }
                <Input label="Nombres*"
                    value={VivirSeguro.nombres}
                    field="nombres"
                    onChange={changeHandler}
                    placeholder='Primer Nombre'

                />
                <Input label="Nombres*"
                    value={VivirSeguro.segundoNombre}
                    field="segundoNombre"
                    onChange={changeHandler}
                    placeholder='Segundo Nombre'
                    onlyInput={true}
                    classNameInput='mt-20'
                    required={false}
                />

                <Input
                    label="Apellidos*"
                    value={VivirSeguro.apellidos}
                    field="apellidos"
                    onChange={changeHandler}
                    placeholder='Primer Apellido'
                ></Input>
                <Input
                    label="Apellidos"
                    value={VivirSeguro.segundoApellido}
                    field="apellidos"
                    onChange={changeHandler}
                    placeholder='Segundo Apellido'
                    onlyInput={true}
                    classNameInput='mt-20'
                    required={false}
                ></Input>

                {VivirSeguro.tipoIdentidad !== "1" &&
                    <DateInput label="Fecha nacimiento" value={VivirSeguro.fechaNacimiento} field="fechaNacimiento" onChange={onChangeDate} valueSelect={VivirSeguro.fechaNacimiento} isRequired={true} />
                }
                <DropDown containBlank={false} isRequired={true} label="Estado Civil*" dataProvider={estadoCivil} valueSelect={VivirSeguro.estadoCivil} fieldSelect="estadoCivil" field="estadoCivil" isrequired={true} onChangeSelect={changeHandler} />

                <Input label="Teléfono de casa*"
                    pattern='\d\d\d\d-\d\d\d\d'
                    type='mask'
                    mask='9999-9999'
                    placeholder="2222-2222"
                    classNameInput="input-field-col"
                    value={VivirSeguro.telefonoCasa}
                    field="telefonoCasa"
                    title="Debe digitar el número de teléfono"
                    onChange={changeHandler} ></Input>
                <Input label="Celular personal*"
                    pattern='\d\d\d\d-\d\d\d\d'
                    title='Teléfono inválido'
                    type='mask'
                    mask='9999-9999'
                    placeholder="8888-8888" value={VivirSeguro.telefonoPersonal} field="telefonoPersonal" onChange={changeHandler}  ></Input>

                <Input label="Correo electrónico*" placeholder="ejemplo@ejemplo.com" value={VivirSeguro.correoElectronico} field="correoElectronico" onChange={changeHandler} />
                <RadioButton
                    label='¿Autoriza a Seguros LAFISE realizar el envío de la documentación de la presente- Póliza al correo electrónico antes proporcionado?*'
                    field='autorizaASL'
                    isCheked={VivirSeguro.autorizaASL}
                    onChange={changeChk}
                />
                <RadioButton
                    label='En caso de surgir controversias futuras en relación al contrato aquí solicitado, ¿Acepta someterse a un proceso de arbitraje institucional, conforme a la ley N° 540 "Ley de Mediación y Arbitraje"?*'
                    field='aceptaPocesoArbitraje'
                    isCheked={VivirSeguro.aceptaPocesoArbitraje}
                    onChange={changeChk}
                />
            </div>
            <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info">
                    {VivirSeguro.mensaje}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );

}
export default Step2;